import { render, staticRenderFns } from "./Company_variable_payroll.vue?vue&type=template&id=64f5c4d8&lang=pug&"
import script from "./Company_variable_payroll.vue?vue&type=script&lang=coffee&"
export * from "./Company_variable_payroll.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports